import { ReportType } from '@modeso/types__aumico-lib-annualreport-be';
import { SortDirection } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/sort-direction.enum';
import { ProjectSortingProperties } from '../../../../../../aumico-lib-projects-fe/src/lib/enums/project-sorting-properties.enum';
import { ProjectStatus } from '../../../../../../aumico-lib-projects-fe/src/lib/enums/project-status.enum';
import { ProjectsFilter } from '../../../../../../aumico-lib-projects-fe/src/lib/interfaces/projects-filter.interface';

export class ProjectsOverviewHelper {
    public static buildProjectsFilter(
        projectsFilter: ProjectsFilter | undefined,
        startDate?: Date | null,
        endDate?: Date | null,
        assignee?: string[] | null,
        projectStatus?: ProjectStatus[] | null,
        companyIds?: string[],
        reportTypeIds?: ReportType[],
        offset?: number,
        limit?: number,
        sortBy?: ProjectSortingProperties,
        sortOrder?: SortDirection,
        searchTerm?: string,
        years?: number[] | null,
    ): ProjectsFilter {
        if (startDate != null) {
            projectsFilter = {
                ...projectsFilter,
                startDate: startDate ? startDate.toISOString() : null,
            };
        }

        if (endDate != null) {
            projectsFilter = {
                ...projectsFilter,
                endDate: endDate ? endDate.toISOString() : null,
            };
        }

        if (assignee !== undefined) {
            projectsFilter = {
                ...projectsFilter,
                assignee: assignee,
            };
        }

        if (projectStatus != null) {
            projectsFilter = {
                ...projectsFilter,
                projectStatus: projectStatus,
            };
        }

        if (companyIds != null) {
            projectsFilter = {
                ...projectsFilter,
                companyIds: companyIds,
            };
        }

        if (reportTypeIds != null) {
            projectsFilter = {
                ...projectsFilter,
                reportTypeIds: reportTypeIds,
            };
        }

        if (offset != null) {
            projectsFilter = {
                ...projectsFilter,
                offset: offset,
            };
        }

        if (limit != null) {
            projectsFilter = {
                ...projectsFilter,
                limit: limit,
            };
        }

        if (sortBy != null) {
            projectsFilter = {
                ...projectsFilter,
                sortBy: sortBy,
            };
        }

        if (sortOrder != null) {
            projectsFilter = {
                ...projectsFilter,
                sortOrder: sortOrder,
            };
        }

        if (searchTerm != null) {
            projectsFilter = {
                ...projectsFilter,
                companyName: searchTerm,
            };
        }

        if (years !== undefined) {
            projectsFilter = {
                ...projectsFilter,
                years: years ?? undefined,
            };
        }
        return projectsFilter;
    }
}
